import React from "react";
import "./registerFooter.scss";
import Tabbable from "../../../components/tabbable";

const Footer = props => (
  <div className="columns register-footer">
    <div className="column centered is-4 is-offset-4">
      <div className="register-footer-label">Já tem cadastro?</div>
      <div className="register-footer-action">
        <Tabbable className="btn" onClick={props.onDoLogin}>
          Fazer login!
        </Tabbable>
      </div>
    </div>
  </div>
);

export default Footer;
